import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useSignInFormStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    ...shorthands.padding(
      tokens.spacingHorizontalNone,
      tokens.spacingHorizontalMNudge,
      tokens.spacingVerticalM,
      tokens.spacingHorizontalMNudge,
    ),
    textAlign: 'center',
  },
  spinner: {
    paddingLeft: tokens.spacingVerticalXS,
  },
});
